export default "assets/images/blason-59b78c96.svg";